import React from 'react'

import {BaseDialog, Role} from 'dialogs/BaseDialog'
import theme from 'dialogs/Complaint.scss'
import Header from 'common/Header'
import Footer from 'common/Footer'
import Form from './Form'
import FormConfirmation from './FormConfirmation'
import {getMessage as msg} from 'MessageBundle'

export default class NewComplaint extends BaseDialog {

    constructor(props) {
        super(props);

        this.view = {
            creation: this.showCreateComplaintForm,
            confirmation: this.showConfirmationPage
        };

        this.state = {
            view: this.view.creation,
            createdComplaint: undefined
        };
    }

    getAllowedRoles() {
        return [Role.ANONYMOUS, Role.SALES_PARTNER, Role.VPQ_OPERATOR];
    }

    componentDidMount() {
        super.init(() => {
            this.complaintReasons = new Map();
            this.state.complaintTypes.filter(t => t.active).forEach(t =>
                t.reasons.filter(r => r.active).forEach(r =>
                    this.complaintReasons.set(r.name, r.name)
                )
            );
            this.setState({
                initialized: true
            })
        });
    }

    showCreateComplaintForm = () => {
        return (
            <div className={theme.wrap}>
                <Header value={msg('complaintManagement.header')}/>
                <section>
                    <Form vo={this.state.vo} email={this.state.email} authenticated={this.state.vo !== undefined}
                        vpqOperator={this.state.vpqOperator} complaintReasons={this.complaintReasons}
                        onComplete={this.changeView(this.view.confirmation)} />
                </section>
                <Footer />
            </div>
        );
    };

    showConfirmationPage = () => {
        return (
            <div className={theme.wrap}>
                <Header value={msg('complaintManagement.header')}/>
                <section>
                    <FormConfirmation complaint={this.state.createdComplaint} authenticated={this.state.vo !== undefined}
                        onStatusLinkClick={() => {this.props.history.push('/status')}}
                        onNewComplaintClick={this.changeView(this.view.creation)}/>
                </section>
                <Footer />
            </div>
        );
    };

    changeView = (view) => (createdComplaint) => {
        this.setState({
            view: view,
            createdComplaint: createdComplaint
        })
    };

    getDialog() {
        return this.state.view();
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/NewComplaint/index.js